import axios from 'axios';

// Determina il baseURL in base all'ambiente
const determineBaseUrl = () => {
  // In ambiente di sviluppo, non aggiungiamo niente perché aggiungeremo /api alle chiamate
  // In produzione sul server, usiamo una stringa vuota per evitare duplicazioni
  if (process.env.NODE_ENV === 'development') {
    // In dev potremmo voler usare un server specifico
    return process.env.REACT_APP_API_URL || '';
  } else {
    // In prod useremo l'URL relativo
    return '';
  }
};

const axiosInstance = axios.create({
  baseURL: determineBaseUrl(),
  withCredentials: true,
});

// Interceptor per aggiungere /api alle URL in qualsiasi ambiente
axiosInstance.interceptors.request.use(config => {
  // Lascia che il browser imposti il boundary corretto per il multipart/form-data
  if (config.data instanceof FormData) {
    if (config.headers) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }
  }

  // Sia in sviluppo che in produzione
  if (config.url && !config.url.startsWith('/api/') && !config.url.startsWith('http')) {
    // Se l'URL non inizia già con /api/ e non è un URL assoluto
    config.url = `/api${config.url}`;
    console.log('URL trasformata:', config.url);
  }
  return config;
});

export default axiosInstance;